/*
 * @Author: your name
 * @Date: 2021-06-09 10:01:55
 * @LastEditTime: 2021-08-11 16:07:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\utils\mockData\referMilkData.js
 */

/**
 * @description refPowder 系统奶量推荐
 * @description refMilk 系统奶量推荐
 * @description customMilk 自定义奶量: 最小 /最大值
 */
 var refPowder = [
    { "maximum": "350"},
    { "maximum": "500"},
    { "maximum": "700"},
    { "maximum": "800"},
    { "maximum": "900"},
    { "maximum": "950"},
    { "maximum": "800"},
    { "maximum": "800"},
    { "maximum": "750"},
    { "maximum": "750"},
    { "maximum": "750"},
    { "maximum": "750"},
    { "maximum": "750"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    // {"minimum": "200","maximum": "500"},
    // {"minimum": "400","maximum": "600"},
    // {"minimum": "500", "maximum": "800"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "800", "maximum": "1000"},
    // {"minimum": "800", "maximum": "1000"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "600", "maximum": "800"},
    // {"minimum": "600", "maximum": "800"},
    // {"minimum": "600", "maximum": "800"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
]


var referMilk = [
    { "maximum": "300"},
    { "maximum": "450"},
    { "maximum": "650"},
    { "maximum": "800"},
    { "maximum": "850"},
    { "maximum": "900"},
    { "maximum": "750"},
    { "maximum": "750"},
    { "maximum": "700"},
    { "maximum": "700"},
    { "maximum": "700"},
    { "maximum": "700"},
    { "maximum": "700"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "600"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    { "maximum": "500"},
    // {"minimum": "150","maximum": "450"},
    // {"minimum": "350", "maximum": "550"},
    // {"minimum": "450", "maximum": "800"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "800", "maximum": "1000"},
    // {"minimum": "800", "maximum": "1000"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "700", "maximum": "900"},
    // {"minimum": "600", "maximum": "800"},
    // {"minimum": "600", "maximum": "800"},
    // {"minimum": "600", "maximum": "800"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "500", "maximum": "700"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
    // {"minimum": "400", "maximum": "600"},
]


var customMilk = {
    // "minimum": [
    //     "150ml",
    //     "200ml",
    //     "350ml",
    //     "400ml",
    //     "450ml",
    //     "500ml",
    //     "600ml",
    //     "700ml",
    //     "800ml",
    // ],
    "maximum": [
        "150ml",
        "200ml",
        "300ml",
        "350ml",
        "450ml",
        "500ml",
        "550ml",
        "600ml",
        "650ml",
        "700ml",
        "750ml",
        "800ml",
        "850ml",
        "900ml",
        "950ml",
        "1000ml",
    ],
}

var capacityColumns = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "15",
    "20",
    "25",
    "30",
    "35",
    "40",
    "45",
    "50",
    "55",
    "60",
    "65",
    "70",
    "75",
    "80",
    "85",
    "90",
    "95",
    "100",
    "105",
    "110",
    "115",
    "120",
    "125",
    "130",
    "135",
    "140",
    "145",
    "150",
    "155",
    "160",
    "165",
    "170",
    "175",
    "180",
    "185",
    "190",
    "195",
    "200",
    "205",
    "210",
    "215",
    "220",
    "225",
    "230",
    "235",
    "240",
    "245",
    "250",
    "255",
    "260",
    "265",
    "270",
    "275",
    "280",
    "285",
    "290",
    "295",
    "300",
]


const milkMlColumns = [
  "1ml",
  "2ml",
  "3ml",
  "4ml",
  "5ml",
  "6ml",
  "7ml",
  "8ml",
  "9ml",
  "10ml",
  "15ml",
  "20ml",
  "25ml",
  "30ml",
  "35ml",
  "40ml",
  "45ml",
  "50ml",
  "55ml",
  "60ml",
  "65ml",
  "70ml",
  "75ml",
  "80ml",
  "85ml",
  "90ml",
  "95ml",
  "100ml",
  "105ml",
  "110ml",
  "115ml",
  "120ml",
  "125ml",
  "130ml",
  "135ml",
  "140ml",
  "145ml",
  "150ml",
  "155ml",
  "160ml",
  "165ml",
  "170ml",
  "175ml",
  "180ml",
  "185ml",
  "190ml",
  "195ml",
  "200ml",
  "205ml",
  "210ml",
  "215ml",
  "220ml",
  "225ml",
  "230ml",
  "235ml",
  "240ml",
  "245ml",
  "250ml",
  "255ml",
  "260ml",
  "265ml",
  "270ml",
  "275ml",
  "280ml",
  "285ml",
  "290ml",
  "295ml",
  "300ml",
]

const feedWeightColumns = [
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '15',
  '20',
  '25',
  '30',
  '35',
  '40',
  '45',
  '50',
  '55',
  '60',
  '65',
  '70',
  '75',
  '80',
  '85',
  '90',
  '95',
  '100',
  '105',
  '110',
  '115',
  '120',
  '125',
  '130',
  '135',
  '140',
  '145',
  '150',
  '155',
  '160',
  '165',
  '170',
  '175',
  '180',
  '185',
  '190',
  '195',
  '200',
  '205',
  '210',
  '215',
  '220',
  '225',
  '230',
  '235',
  '240',
  '245',
  '250',
  '255',
  '260',
  '265',
  '270',
  '275',
  '280',
  '285',
  '290',
  '295',
  '300',
  '305',
  '310',
  '315',
  '320',
  '325',
  '330',
  '335',
  '340',
  '345',
  '350'
]
export {refPowder, referMilk, customMilk, capacityColumns, feedWeightColumns}